import analyticUtils from '../analytics-integrations/analytics-utils';

const pendingReviewWithSnoozeViewed = function (properties) {
  if (!analyticUtils.segmentLoaded()) return;
  analytics.track('review_modal_loaded_by_host', properties);
}

const snoozeButtonPressed = function (count, deviceType, ssoid, bookingId) {
  if (!analyticUtils.segmentLoaded()) return;
  const properties = {
    count,
    deviceType,
    ssoid,
    bookingId
  };
  analytics.track('snooze review clicked', properties);
};

export default { pendingReviewWithSnoozeViewed, snoozeButtonPressed };
